import {
  CallToolResult,
  ContentBlock,
  TextContent,
} from '@modelcontextprotocol/sdk/types.js';

export const createTextContent = (text: string): TextContent => ({
  type: 'text' as const,
  text,
});

export const createCallToolResult = ({
  contentBlocks,
  isError,
}: {
  contentBlocks: ContentBlock[];
  isError?: boolean;
}): CallToolResult => ({
  content: contentBlocks,
  isError,
});

export default { createCallToolResult, createTextContent };
